import { BaseQueryFn, FetchArgs, FetchBaseQueryError, fetchBaseQuery } from '@reduxjs/toolkit/dist/query';
import { SettingsState, getSettings } from '@vxui/common';
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { AvailableMetric } from '../models/metrics';

const rawBaseQuery = fetchBaseQuery();
const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const settings = getSettings(api.getState() as SettingsState);
  const urlEnd = typeof args === 'string' ? args : args.url;
  const adjustedUrl = `${settings?.servers.serverMetricsProvider ?? ''}/api/v1/${urlEnd}`;
  const adjustedArgs = typeof args === 'string' ? adjustedUrl : { ...args, url: adjustedUrl };
  return rawBaseQuery(adjustedArgs, api, extraOptions);
};

export const metricsProviderApi = createApi({
  reducerPath: 'metricsProviderApi',
  baseQuery: dynamicBaseQuery,
  endpoints: builder => ({
    getAvailableMetrics: builder.query<AvailableMetric[], void>({
      query: () => `metric`,
      transformResponse: (response: { data: AvailableMetric[] }) =>
        response.data.map(entry => {
          if (entry.min === -1) entry.min = undefined;
          if (entry.max === -1) entry.max = undefined;
          if (entry.primaryColor === '') entry.primaryColor = undefined;
          return entry;
        }),
    }),
  }),
});

export const { useGetAvailableMetricsQuery } = metricsProviderApi;
